import React, { Component } from 'react'
import { Form, Field } from 'redux-form'

import { Container } from 'components/Layout'
import Button from 'components/Button'
import SelectPretty from 'components/Input/SelectPretty'
import { Textarea } from 'components/Input/Textarea'
import { vRequired } from 'components/Input/Input.validations'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

const enquiryOptions = [
  'Wholesale Toll Feeds queries',
  'Invoice issue/delay',
  'Charge query (not dispute)',
  'Billing Address updates',
  'Usage call report/verification',
  'Refund request',
  'Other',
].map(item => ({ value: item, name: item }))

export default class CasesCreateEnquiryModal extends Component {
  onSubmit = formData => {
    const { createEnquiry, modalConfirm } = this.props
    return createEnquiry(formData).then(modalConfirm)
  }
  render() {
    const { modalCancel, submitting, handleSubmit, change, bills, invalid } = this.props

    const billOptions = bills.map(bill => ({
      name: `${bill.billNumber} - $${bill.total}`,
      value: bill.billNumber,
    }))

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Submit a bill enquiry:</div>
          <br />
          <Form onSubmit={handleSubmit(this.onSubmit)}>
            <Field
              label="Bill you are enquiring about"
              name="invoice"
              component={SelectPretty}
              options={billOptions}
              onChangeAlt={billNumber => {
                change('ban', bills.find(bill => bill.billNumber === billNumber).ban)
              }}
              validate={[vRequired]}
            />
            <Field
              label="Type of Enquiry"
              name="type"
              component={SelectPretty}
              options={enquiryOptions}
              validate={[vRequired]}
            />
            <Field
              label="Description"
              name="description"
              display="standard"
              component={Textarea}
              validate={[vRequired]}
            />
            <div
              className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
              style={{ marginTop: '40px' }}
            >
              <Button color="tertiary" type="submit" loading={submitting} disabled={submitting || invalid}>
                Submit
              </Button>
              <br />
              <br />
              <Button plain onClick={modalCancel}>
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateEnquiryModal/CasesCreateEnquiryModal.jsx